export class Colors {
	primaryColor = "#f8f9fa";
	secondaryColor = "#007bff";
	accentColor = "#007bff"; 
	errorColor = "#f44336";
	successColor: "#4caf50";
	linkColor = "#007bff";
}